<template>
  <div class="hp-manager-page-list">
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="false" :loading="loading" @tableChange="tableChange">
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch v-model="rowKey.data.isActive" @change="activeChange(rowKey.data)" :disabled="true" />
        </span>
      </template>
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [],
      columns: [
        {
          title: "销售组织",
          dataIndex: "organizationName",
          sorter: true,
          width: 200
        },
        {
          title: "修改时间",
          width: 150,
          dataIndex: "creationTime",
          width: "15%",
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: "状态",
          width: "10%",
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        }
      ],
      datas: [],
      filterdata: Object.assign(JSON.parse(JSON.stringify(config.pageFilter))),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      productId: 0,
      title: ""
    };
  },
  async mounted() {
    this.productId = this.paramsX.id;
    this.getDatas();
  },
  methods: {
    handleSubmit(p) {
      this.getDatas();
    },

    refreshCurrent() {
      this.getDatas();
    },
    tableChange(table) {
      this.getDatas();
    },

    async getDatas() {
      this.loading = true;
      let data = await api.GetProductOrgList({ productId: this.productId });
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/Product/RelationOrgList.vue